const Backofficebff: string = import.meta.env.VITE_BACKOFFICEBFF!;

export const RawImageUploadCommandURL = {
    RegisterFile: Backofficebff + '/v1/raw-image-upload/files',
    UpdatePhotoType: Backofficebff + '/v1/raw-image-upload/files/photo-type',
    DeleteFile: Backofficebff + '/v1/raw-image-upload/files/delete',
    CompleteUpload: Backofficebff + '/v1/raw-image-upload/complete',
};
